<script>
  import { gun } from "../gun.js";
  export let canvasNode;
  export let showAll;
  let logContainer;

  const scrollToBottom = (node) => {
    node.scrollTop = node.scrollHeight;
  };

  let logStore = {};
  gun
    .get(canvasNode + "-editors")
    .map()
    .on(function (data, key) {
      if (data) {
        logStore[key] = GUN.state.is(data, "sessionStart");

        if (logContainer) scrollToBottom(logContainer);
      }
    });

  $: logs = showAll
    ? Object.entries(logStore)
    : Object.entries(logStore).slice(-100);
  $: logsSorted = logs.sort();
</script>

<h3 class="mt-3 mb-0 font-black text-white">EDITORS:</h3>
<div id="logs" bind:this={logContainer}>
  <div class="log-container log-header">
    <div class="log">SESSION START TIME</div>
    <div class="log">USER</div>
  </div>
  <div class="log-container mt-5 log-item">
    <div class="log">...</div>
    <div class="log">...</div>
  </div>
  {#each logsSorted as [key, log]}
    <div class="log-container log-item">
      <div class="log">{new Date(log).toLocaleString()}</div>
      <div class="log editor-key">{key}</div>
    </div>
  {/each}
</div>

<style>
  #logs {
    max-height: 100px;
    height: 100px;
    margin-top: 1px;
    overflow-y: scroll;
    width: 600px;
    max-width: 95vw;
  }
  .log {
    display: inline-block;
    overflow: hidden;
    font-size: 0.6rem;
    font-weight: 700;
  }
  .log-item {
    margin-left: 3px;
  }
  .log-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .log-header {
    position: absolute;
    width: 600px;
    max-width: 95vw;
    background: #0a0a0a;
    padding: 3px 5px;
  }
  div {
    color: white;
  }
  @media only screen and (max-height: 900px) {
    #logs,
    .log-header {
      width: 65vh;
    }
  }
</style>
